import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  CHECK_SPECIALIST_AUTH_HISTORY_REQUEST: '',
  CHECK_SPECIALIST_AUTH_HISTORY_SUCCESS: '',
  CHECK_SPECIALIST_AUTH_HISTORY_FAILURE: '',

  VALIDATE_OPT_OPH_REQUEST: '',
  VALIDATE_OPT_OPH_SUCCESS: '',
  VALIDATE_OPT_OPH_FAILURE: '',

};

types = setStoreTypeValues(types, 'authSpecialists');

export default types;
